import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const validarHojaQuirurgicaUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/validacion";

const registrarCoberturaUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/validacion/cobertura";

const registrarAnexoUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/validacion/anexo";

const obtenerPacientesIngresadosUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/consultaingresospss";

const registrarImagenBlobStorageUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/imagen-blob-storage";

const validarHojaQuirurgica = (request) =>
  InterceptToken(
    BaseApi.post,
    validarHojaQuirurgicaUrl,
    request?.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const registrarCobertura = (request) =>
  InterceptToken(
    BaseApi.post,
    registrarCoberturaUrl,
    request?.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const registrarAnexo = (request) =>
  InterceptToken(
    BaseApi.post,
    registrarAnexoUrl,
    request?.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const obtenerPacientesIngresados = (request) =>
  InterceptToken(
    BaseApi.get,
    request?.url ||
      `${obtenerPacientesIngresadosUrl}?numeroMedico=${request?.NumeroMedico}`,
    null,
    request?.requestHeaders
  ).then((response) => {
    const resultado = response.data;
    
    return resultado;
  });

const registrarImagenBlobStorage = async (request) => {
  const formData = new FormData();
  formData.append("file", request.file);
  formData.append("metadata", request.metadata || "");
  formData.append("Authorization", request.authorization || "");

  const response = await InterceptToken(
    BaseApi.post,
    registrarImagenBlobStorageUrl,
    formData,
    {
      ...request.requestHeaders,
      "Content-Type": "multipart/form-data",
    }
  );

  return response.data;
};

const obtenerEstatusCoberturasHojaQXUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/consulta-estatus-hojaqx";

const consultarDetalleAnexosUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/consulta-detalle-anexos";

const consultarDetalleCoberturaUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/consultadetallecobertura";

const actualizarPertinenciaMedicaUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/pertinencia-medica";

  const actualizarEnvioHojaQxUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/enviohojaqx";
  
const actualizarPertinenciaMedica = (request) =>
  InterceptToken(
    BaseApi.put,
    actualizarPertinenciaMedicaUrl,
    request?.requestData,
    request?.requestHeaders
  ).then((response) => response.data);

const actualizarEncuestaCesUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/encuesta";

const actualizarEncuestaCes = (request) =>
  InterceptToken(
    BaseApi.put,
    actualizarEncuestaCesUrl,
    request?.requestData,
    request?.requestHeaders
  ).then((response) => response.data);

const actualizarEnvioHojaQx = (request) =>
  InterceptToken(
    BaseApi.patch,
    actualizarEnvioHojaQxUrl,
    request?.requestData,
    request?.requestHeaders
  ).then((response) => response.data);

const consultarEstatusHojasQX = async (request) => {
  const params = [];
  if (request?.requestParams?.numeroIngreso) {
    params.push(`numeroIngreso=${request.requestParams.numeroIngreso}`);
  }
  if (request?.requestParams?.codigoPss) {
    params.push(`codigoPss=${request.requestParams.codigoPss}`);
  }
  if (request?.requestParams?.fechaInicio) {
    params.push(`fechaInicio=${request.requestParams.fechaInicio}`);
  }
  if (request?.requestParams?.fechaFin) {
    params.push(`fechaFin=${request.requestParams.fechaFin}`);
  }
  if (request?.requestParams?.pagina) {
    params.push(`pagina=${request.requestParams.pagina}`);
  }
  if (request?.requestParams?.tamanoPagina) {
    params.push(`tamanoPagina=${request.requestParams.tamanoPagina}`);
  }
  
  const queryString = params.length > 0 ? `?${params.join("&")}` : "";
  
  const response = await InterceptToken(
    BaseApi.get,
    `${obtenerEstatusCoberturasHojaQXUrl}${queryString}`,
    null,
    {
      ...request.requestHeaders,
    }
  );

  return response.data;
};

const consultarDetalleAnexos = async (request) => {
  const params = [];
  
  if (request?.requestParams?.secuencial) {
    params.push(`secuencial=${request.requestParams.secuencial}`);
  }
  if (request?.requestParams?.pagina) {
    params.push(`pagina=${request.requestParams.pagina}`);
  }
  if (request?.requestParams?.tamanoPagina) {
    params.push(`tamanoPagina=${request.requestParams.tamanoPagina}`);
  }
  
  const queryString = params.length > 0 ? `?${params.join("&")}` : "";
  
  const response = await InterceptToken(
    BaseApi.get,
    `${consultarDetalleAnexosUrl}${queryString}`,
    null,
    {
      ...request.requestHeaders,
    }
  );

  return response.data;
};

const consultarDetalleCobertura = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    `${consultarDetalleCoberturaUrl}?secuencial=${request?.requestParams?.secuencial}`,
    null,
    {
      ...request.requestHeaders,
    }
  );

  return response.data;
};

const exportedObject = {
  validarHojaQuirurgica,
  registrarCobertura,
  registrarAnexo,
  obtenerPacientesIngresados,
  registrarImagenBlobStorage,
  consultarEstatusHojasQX,
  consultarDetalleAnexos,
  consultarDetalleCobertura,
  actualizarPertinenciaMedica,
  actualizarEncuestaCes,
  actualizarEnvioHojaQx,
};

export default exportedObject;
